import { render, staticRenderFns } from "./CallsTable.vue?vue&type=template&id=a50f95bc&scoped=true&"
import script from "./CallsTable.vue?vue&type=script&lang=js&"
export * from "./CallsTable.vue?vue&type=script&lang=js&"
import style0 from "./CallsTable.vue?vue&type=style&index=0&id=a50f95bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f95bc",
  null
  
)

export default component.exports